/**
 * @typedef {Object} NewAttendanceFormState
 * @property {object} attendance
 * @property {object} disease
 * @property {object[]} treatments
 * @property {object} questions
 * @property {object} answers
 * @property {object} parameters
 * @property {object} extraAnswers
 * @property {object} patientData
 * @property {Record<string, {shouldRun: boolean, callbacks: (() => Promise<void>)[]}>} sideEffects
 * @property {number} version
 * @property {boolean} isSaving
 * @property {boolean} isSynced
 */

/** @typedef {{[key in keyof NewAttendanceFormState]: () => NewAttendanceFormState[key]}} ComputedNewAttendanceFormState */

export const baseExtraAnswers = { simplified: true }
export const getInitialState = () => ({
  attendance: {},
  disease: {},
  treatments: [],
  questions: {},
  answers: {},
  parameters: {},
  extraAnswers: baseExtraAnswers,
  patientData: {},
  sideEffects: {},
  version: null,
  isSaving: false,
  isSynced: true,
})

/** @type {NewAttendanceFormState} */
export default getInitialState()
